import { Logo } from '../components/Logo'
import styled from 'styled-components';
import { Aco } from '../components/Aco';

const data = [
  {en: "1,8-cineole", ja: "1,8-シネオール", rebge: "Max:6", value: "5.53%"},
  {en: "Limonene", ja: "リモネン", rebge: "Max:6", value: "3.31%"},
  {en: "Linalool", ja: "リナロール", rebge: "20-45", value: "23.4%"},
  {en: "Camphor", rebge: "Max1.4", value: "0.88%"},
  {en: "Terpinen-4-ol", rebge: "0.1-6.0", value: "0.29%"},
  {en: "Alpha-terpineol", rebge: "Trace to 7", value: "3.37%"},
  {en: "Linalyl acetate", rebge: "25-46", value: "43.31%"},
]

const Layout = styled.div`
  text-align: left;
  display: inline-block;
  padding: 20px;
`

const LogLayout = styled.div`
  text-align: center;
  margin: 60px 0;
`

const LeftLayout = styled.div`
  float: left;
  padding: 0 0 40px 0;
  @media screen and (min-width:960px) {
    width: 545px;
  }
`

const RightLayout = styled(LeftLayout)`
  @media screen and (min-width:960px) {
    margin: 0 0 0 40px;
    width: 335px;
  }
`

const NumberData = styled.td`
  text-align: right;
`

const detail = [
  {title: '原産国', value: 'フランス'},
  {title: '抽出部位', value: '花/葉'},
  {title: '抽出方法', value: '水蒸気蒸留法'},
  {title: '学名', value: 'Lavandula angustifolia'},
  {title: '科名', value: 'シソ科'},
  {title: '効果', value: '安眠、免疫力強化、肩こり、ニキビ、肌のアンチエイジング、虫除け'}
];

export const Lavandula8 = () => <Layout>
  <LogLayout>
    <Logo />
  </LogLayout>
  <LeftLayout>
    <h2>使用期限</h2>
    <p>{new Date(new Date('2027-07-01T00:00:00.000+09:00').getTime() - 1).toLocaleDateString()}</p>
    <h2>スペック</h2>
    <table>
      <tbody>
        {detail.map((item, index) => <tr key={index}>
          <th>{item.title}</th><td>{item.value}</td>
        </tr>)}
      </tbody>
    </table>
    <h2>Certification of analysis</h2>
    <h3>1. PRODUCT IDENTIFICATION AND COMPOSITION</h3>
    <ul>
      <li>1.1 Product Name: Lavender True</li>
      <li>1.2 Botanical Name: Lavandula angustifolia</li>
    </ul>
    <p>TEST SPECIFICATION RESULT</p>
    <h3>2. PHYSICAL AND CHEMICAL PROPERTIES</h3>
    <ul>
      <li>2.1 Appearance: Clear, pale yellow to yellow liquid Conforms</li>
      <li>2.2 Odour: Characteristic Conforms</li>
      <li>2.3 Specific Gravity: 0.8750 to 0.8950 @ 20°C Conforms</li>
      <li>2.4 Refractive Index: 1.4550 to 1.4700 @ 20°C Conforms</li>
    </ul>
    <p>CONSTITUENT SPECIFICATION RESULT</p>
    <h3>3. GAS CHROMATOGRAPH ANALYSIS Results</h3>
    <table>
      <tbody>
        {data.map((item, index) => <tr key={index}>
          <th>{item.en}</th><NumberData>{item.value}</NumberData>
        </tr>)}
      </tbody>
    </table>
  </LeftLayout>
  <RightLayout>
    <Aco />
  </RightLayout>
</Layout>